
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trains",
      function () {
        return require("private-next-pages/trains.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trains"])
      });
    }
  